/**
 * India vs abroad for any user residential address (students, tutors, etc.).
 * null / undefined indianResident is treated as India for backward compatibility.
 */
export function isIndianResidentialAddress(address) {
  return address == null || address.indianResident !== false;
}

/** Same as {@link isIndianResidentialAddress}; kept for existing student-screen imports. */
export function isIndianStudentAddress(address) {
  return isIndianResidentialAddress(address);
}
